/**
 * This file is categorized as "Proprietary Framework Code"
 * and is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */
import {
	Icon,
	Row,
	Select,
} from 'native-base';
import {
	FontAwesome5,
} from '@expo/vector-icons';
import testProps from '../../functions/testProps';
import _ from 'lodash';

export default function Picker(props) {
	const {
			entities,
			allowNull = true,
			cutoff = 25,
			nullLabel = 'None',
			_select = {},
		} = props,
		items = _.map(entities, (entity) => {
			let label = entity.displayValue;
			if (label.length > cutoff) {
				label = label.substring(0, 25) + '...';
			}
			return <Select.Item key={entity.id} label={label} value={entity.id} {...testProps('PickerItem-' + entity.id)} />;
		});

	if (allowNull) {
		items.unshift(<Select.Item key="null" label={nullLabel} value={null} {...testProps('PickerItem-null')} />);
	}

	const selectedValue = _select.selectedValue;
	if (!allowNull && !selectedValue) {
		_select.borderColor = '#f00';
		_select.borderWidth = 1;
	}

	// Set an explicit dropdownIcon to add margin to it, so it looks better
	return <Row h={10} {...props}>
				<Select
					placeholder="Select"
					isDisabled={false}
					dropdownIcon={<Icon as={FontAwesome5} name="chevron-down" size="xs" mr={3} color="trueGray.500" />}
					{..._select}
				>{items}</Select>
			</Row>;
}

